import { ViewClassesTranslations } from './types';

export const deTranslations: ViewClassesTranslations = {
    title: "Sessions anzeigen",
    columns: {
        className: "Session-Name",
        classCode: "Session-ID",
        status: "Status",
        patientsSeen: "Gesehene Patienten",
        patientsDischarged: "Entlassene Patienten",
        dateCreated: "Erstellungsdatum",
        review: "Überprüfung"
    },
    actions: {
        review: "Überprüfen"
    },
    errors: {
        loadingFailed: "Klassen konnten nicht geladen werden"
    }
};